import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommunityUserExtended } from '../models/community-user-extended.model';
import { map } from 'rxjs/internal/operators/map';
import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';
import { environment } from '@environment';

@Injectable({ providedIn: 'root' })
export class CommonUserService {
    private user;
    private userObservable: Observable<CommunityUserExtended>;

    constructor(private http: HttpClient) {}

    getFullInfo(): Observable<CommunityUserExtended> {
        if (this.user) {
            return of(this.user);
        } else if (this.userObservable) {
            return this.userObservable;
        } else {
            this.userObservable = this.http.get(environment.apiInboxUrl + 'users/FullUserInfo').pipe(
                map((data) => {
                    this.user = data;
                    return this.user;
                }),
            );
            return this.userObservable;
        }
    }
}
